import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { styled } from 'styletron-react';
import { zIndexes } from '../../const/zIndexes';
import { Box } from '../layout/Box';
import { DynamicTableCell } from './DynamicTableCell';
import { DynamicTableHeaderCell } from './DynamicTableHeaderCell';
import { DynamicTableLayout } from './DynamicTableLayout';
import { DynamicTableRow } from './DynamicTableRow';
const StyledDynamicTableRow = styled('tr', {
    position: 'sticky',
    top: 0,
    zIndex: zIndexes.tableRowHeader,
});
export const DynamicTable = ({ table, CellClickableWrapper, disableHeader = false, }) => {
    const leafHeaders = table.getLeafHeaders();
    const headerCells = leafHeaders.map((header, columnIndex) => {
        const { column } = header;
        const isSortable = column.getCanSort();
        const sortDirection = column.getIsSorted() || undefined;
        const content = flexRender(column.columnDef.header, header.getContext());
        const handleClick = column.getToggleSortingHandler();
        return (_jsx(DynamicTableHeaderCell, { totalColumns: leafHeaders.length, columnIndex: columnIndex, isSortable: isSortable, sortDirection: sortDirection, onClick: handleClick, children: content }, header.id));
    });
    const rows = table.getRowModel().rows.map((row) => {
        const rowId = row.id;
        const isClickable = !!CellClickableWrapper;
        const cells = row.getVisibleCells().map((cell) => {
            const cellId = cell.id;
            const content = flexRender(cell.column.columnDef.cell, cell.getContext());
            return (_jsx(DynamicTableCell, { rowId: rowId, rowData: row.original, columnId: cell.column.id, CellClickableWrapper: CellClickableWrapper, children: content }, cellId));
        });
        return (_jsx(DynamicTableRow, { isClickable: isClickable, children: cells }, rowId));
    });
    const shouldShowHeader = !disableHeader;
    return (_jsx(Box, { overflow: 'auto', children: _jsxs(DynamicTableLayout, { children: [shouldShowHeader && (_jsx("thead", { children: _jsx(StyledDynamicTableRow, { children: headerCells }) })), _jsx("tbody", { children: rows })] }) }));
};
